var mobMenu = false;
var bgnav;
var hdrWidth, logoWidth, nrOfPage;				
var navWidth = 10;
var tOutID;
var roothtml = "/";



$(window).resize(function(){
    sizeWin();
    popupResize();
});

$(document).ready(function() {
    $('header nav ul li').each(function(){
        navWidth += $(this).outerWidth(true);
    });
    
    sizeWin();
    popupResize();
    deskSubMenu();
    ckEditBox();
    turfForm();
});


var randomScalingFactor = function() {
    return Math.round(Math.random() * 100);
};
var options = {
    legend:{
        display:false
    },
    responsive: true, 
    maintainAspectRatio: true 
}


$(document).ready(function() {
    if($(".filters").length){
        
        
        $("body").on('click','.printPDFbtn',function(){
            window.print();
        });
        
        var data = $("#statFilters").serialize();
        
        axios.get("/statistiek/data?"+data)
            .then(function (respons) {
                //// console.log(respons);
                var data = respons.data;
                
                
                
                // update turfPerCat doughnut
                var config = {
                    type: 'doughnut',
                    data: {
                        datasets: [{
                            data: data.turfPerCat.list.values,
                            backgroundColor: data.turfPerCat.list.colors,
                        }],
                        labels: data.turfPerCat.list.labels
                    },
                    options: options
                };
                var ctx = document.getElementById('ttpc_doughnut').getContext('2d');
                window.myDoughnut = new Chart(ctx, config);
                
                
                
                
                
                
                
                // update turfsPerHour line / bar chart
                var chartData = {
                    labels: data.turfsPerHour.labels,
                    datasets: [{
                        type: 'line',
                        label: data.turfsPerHour.dataset[0].label,
                        backgroundColor: data.turfsPerHour.dataset[0].color,
                        borderColor: data.turfsPerHour.dataset[0].color,
                        pointBackgroundColor: data.turfsPerHour.dataset[0].color,
                        fill: false,
                        data: data.turfsPerHour.dataset[0].data
                    }]

                };
                
                // add received data
                for(var i=1; i < data.turfsPerHour.dataset.length; i++){
                    chartData.datasets.push({
                        type: 'bar',
                        label: data.turfsPerHour.dataset[i].label,
                        backgroundColor: data.turfsPerHour.dataset[i].color,
                        data: data.turfsPerHour.dataset[i].data
                    });
                }
                
                var config = {
                    type: 'bar',
                    data: chartData,
                    options: {
                        elements: {
                            line: {
                                fill: false
                            }
                        },
                        scales: {
                            yAxes: [
                                {
                                    ticks: {
                                        beginAtZero: true
                                    }
                                }
                            ]
                        },
                        responsive: true,
                        maintainAspectRatio: true
                    }
                }
                
                var ctx = document.getElementById('ttpu_comBarLine').getContext('2d');
                window.myMixedChart = new Chart(ctx, config);
                
                
                
                
                
                
                // update turfsPerDay bar chart
                var chartData = {
                    labels: data.turfsPerDay.labels,
                    datasets: [{
                        type: 'bar',
                        backgroundColor: "#28a745",
                        data: data.turfsPerDay.values
                    }]
                }
                var config = {
                    type: 'bar',
                    options: {
                        legend:{
                            display:false
                        },
                        responsive: true, 
                        maintainAspectRatio: true, 
                        scales: { 
                            yAxes: [
                                { 
                                    stacked: true, 
                                    ticks: { 
                                        beginAtZero: true 
                                    },
                                }
                            ], 
                            xAxes: [
                                { 
                                    stacked: true,
                                }
                            ] 
                        },
                    },
                    data: chartData
                }
                var ctx = document.getElementById('tgpd_bar').getContext('2d');
                window.myBarChart  = new Chart(ctx, config);
                
                
                
                
                
                // update turfsGemPerHour bar chart
                var chartData = {
                    labels: data.turfsGemPerHour.labels,
                    datasets: [{
                        type: 'bar',
                        backgroundColor: '#0d47a1',
                        data: data.turfsGemPerHour.values
                    }]
                }
                var config = {
                    type: 'bar',
                    options: {
                        legend:{
                            display:false
                        },
                        responsive: true, 
                        maintainAspectRatio: true, 
                        scales: { 
                            yAxes: [
                                { 
                                    stacked: true, 
                                    ticks: { 
                                        beginAtZero: true 
                                    },
                                }
                            ], 
                            xAxes: [
                                { 
                                    stacked: true,
                                }
                            ] 
                        },
                    },
                    data: chartData
                }
                var ctx = document.getElementById('tgph_bar').getContext('2d');
                window.myBarChart  = new Chart(ctx, config);
                
                
            })
            .catch(function (error) {
                //// console.log(error);
            });
    }
});	






var refInt		    = "";
var turfInProgress  = false;
var locSlug 	    = "";
var dt 			    = "";
var currDate 	    = "";
var currHour 	    = "";
var currMin 	    = "";
var minToGo 	    = 1;

function turfSyncData(){
    locSlug 	= $("#locSlug").val();
    dt 			= new Date();
    currDate 	= dt.getFullYear() + "-" + twoDigit(dt.getMonth()+1) + "-" + twoDigit(dt.getDate());
    currHour 	= dt.getHours();
    currMin 	= dt.getMinutes();
    
    
    const data 		= {
        params: {
            currDate: currDate,
            currHour: currHour
        }
    };
    // console.log(data);
    axios.get("/turven/locatie/" + locSlug + "/form", data)
        .then(function (respons) {

            // console.log(respons);
            $("#turfFormHld").html(respons.data);
            
            // refesh every hour
            // refInt = setInterval(function(){ turfForm(); }, minToGo*60000);
        });
}



function turfForm(){
    if($("#turfFormHld").length){			
        turfSyncData();
        refInt = setInterval(function(){ turfSyncData(); }, minToGo*60000);
            
        $("body").on("click", "#turfTable .turfMin", function(e){
            e.preventDefault();
            
            if(!turfInProgress){
                var catId       = $(this).attr("data-catId");
                turfInProgress  = true;
                
                turfAction(catId, "min");
            }
        });				
        
        $("body").on("click", "#turfTable .turfAdd", function(e){
            e.preventDefault();

            if(!turfInProgress){
                var catId       = $(this).attr("data-catId");
                turfInProgress  = true;
                
                turfAction(catId, "add");
            }
        });
    }
}


function turfAction(catId, type){
    clearInterval(refInt);

    // console.log(refInt);

    
    const data = {
        params: {
            currDate: currDate,
            currHour: currHour,
            catId	: catId,
            type	: type,
        }
    };

    // console.log(data);
    
    axios.get("/turven/locatie/" + locSlug + "/turf", data)
        .then(function (respons) {
            $("#turfFormHld").html(respons.data);

            // console.log(respons);
            
            // refesh every hour
            //refInt = setInterval(function(){ reload_page(); }, minToGo*60000);
            refInt          = setInterval(function(){ turfSyncData(); }, minToGo*60000);
            turfInProgress  = false;
            // console.log(refInt);
        })
        .catch(function (error) {
            cusAlert('Error', 'Could not get the add page. Are you logged in?');
        });
}



function ckEditBox(){
    if($('.textbox').length){

        var config ={
            customConfig: '/vendor/unisharp/laravel-ckeditor/customConfig.js',
            toolbar: $('.textbox').attr('data-toolbar'),
        };
        
        $('.textbox').ckeditor(config);
    }
}

function sizeWin(){
    hdrWidth = $('header').width();
    logoWidth = $('#logo').width();
    nrOfPage = $('header nav ul li').length;

    if(hdrWidth <= "550"){
        $('#logo').addClass('mob');
        $("#hdr_main_nav").prepend($("#options"));
        
        
    }else{
        $('#logo').removeClass('mob');
        $("#head-right").prepend($("#options"));
    }		

    // if nav does not fit in the header, add mob class to nav and show mob menu button
    if(hdrWidth > (navWidth+logoWidth+20)){
        if(mobMenu == true){
            mobMenu = false;
            bgnav.fadeOut('fast');
            $('header nav').slideUp('fast');
        }
        $('#mobmenubtn').hide();
        
        $('header nav').removeClass('mob').show();
        $('#hdr_main_nav').css('top', '');
    }else{
        $('#mobmenubtn').show();
        
        $('header nav').addClass('mob').hide();
        $('#hdr_main_nav').css('top', ($('header').height()+9)+'px');
    }
    
    var screenHeight = $('body').height();
    $('footer').css("position","relative");

    // cp options
    if(hdrWidth <= "550"){
        if($(".tdata_options .mobOptBtn").length == 0) {
            $('.tdata_options').css('width','10px');
            $('.tdata_options .opt_hld:hidden').after('<div class="mobOptBtn"><img src="/img/mob-option.png" /></div>');
        }
    }else{
        if($(".tdata_options .mobOptBtn").length != 0) {
            $('.tdata_options .mobOptBtn').remove();
        }
    }
}

function delayedSlideUp(trigElmntID){
     tOutID = setTimeout(function(){
    $('#'+trigElmntID).nextAll().slideUp(300);
    },3000);
}
function deskSubMenu(){
    $('#hdr_main_nav > ul > li:has(.submenu)').mouseover(function(){
        if($(window).width() > "850"){
            var trigElmntID = $(this).attr("data-nav-el");
            $('#hdr_main_nav > ul > li > .submenu').not($(this).children('.submenu')).slideUp(300);
            $(this).children('.submenu').slideDown(500);
            clearTimeout(tOutID);
            delayedSlideUp(trigElmntID);
        }
    });
}



/**
FancyTable related function & actions
*/

// on table searchbox keyup
$("body").on('keyup','#content .searchbox',function(e){
    var thisEl		= $(this);
    var href 		= thisEl.attr('data-url');
    var search 		= thisEl.val();

    delay(function(){
            if(search != ""){
                href = href + "?orderby=title&order=ASC"
            }
            $.ajax({
                    type: "POST",
                    url: href,
                    data: {ajaxmode : 1, search : search},
                    success: function(data) {
                        $("#content").html(data);
                        
                        $("#content .searchbox").focus();
                        $("#content .searchbox").setCursorToTextEnd();
                        refreshData();
                    }
            });
    }, 800 );

    return false;
});


// change table action description to the title of this button
$("body").on('click','.mobOptBtn',function(){
    if($(this).parent().find('.opt_hld:visible').length == 0){
        $('.tdata_options .opt_hld').hide();
        $(this).parent().find('.opt_hld').show();
    }else{
        $(this).parent().find('.opt_hld').hide();
    }
});


// change table action description to the title of this button
$("body").on('mouseover','.opt_hld a',function(){
    var title = $(this).attr('title');
    $(this).parents('table').find(".options_hdr").html(title).css("color","#FFF");
    return false;
});

// return  table action description to default "Action"
$("body").on('mouseleave','.opt_hld a',function(){
    var title = $(this).attr('title');
    $(this).parents('table').find(".options_hdr").html("Action").css("color","grey");
    return false;
});


/**
popup related function & actions
*/

//var popupOrgHeight = "";



function openPopup(title, content, closeCallback = "", footer = ""){
        var popupHtml = '<div class="bgPopup"><div class="popupCnt"><div class="pop_hdr"><h1>'+ title +'</h1><div class="closePop"><a href="#"><img src="/img/icons/bw/16/close.png" alt="Close"></a></div></div><div class="pop_content">'+ content + '</div></div><div class="clearem"></div></div>';
        var popup = $(popupHtml);
        
        
        
        if($(".bgPopup").length == 0) {
            $("header").after(popup);
        }else{
            $(".bgPopup:last").after(popup);
            
        }
        
        popup.fadeIn('fast', function(){
            popupResize();
        });
        
        $('.popupCnt .closePop').click(function() {
                if(closeCallback){closeCallback();}
                closePopup(true);
        });
        
        
        function closePopup(clean=true){
                popup.fadeOut('fast');
                popup.children('.popupCnt').fadeOut('fast', function(){
                    popup.remove();
                });
        }
        
        this.closePopup = function() {
            closePopup(true);
        }
}





function cusAlert(title, message, yesCallback) {

        var content = '<div class="popuptext">'+ message +'</div>';
        content += '<div class="popupBtnBar"><button class="btnYes">Ok</button></div>';
        
        var thispop = new openPopup(title, content);

        $('.popupCnt .btnYes').click(function() {
            if(yesCallback){yesCallback();}
            thispop.closePopup(true);
        });
}


function cusDialog(title, message, yesCallback, noCallback) {

        var content = '<div class="popuptext">'+ message +'</div>';
        content += '<div class="popupBtnBar"><button class="btnYes">Yes</button><button class="btnNo">Cancel</button></div>';
        
        var thisPopup = new openPopup(title, content);

        $('.popupCnt .btnYes').click(function() {
                //dialog.dialog('close');
                yesCallback(thisPopup);
        });
        
        $('.popupCnt .btnNo').click(function() {
                //dialog.dialog('close');
                if(noCallback){noCallback(thisPopup);}
        });
}


function popupResize(){
    if($('.popupCnt').length){
        $('.popupCnt').each(function () {
            
            var newHeight = $(this).height();
            var minHeight = 0;
            
            if($('.pop_hdr', this).length){
                minHeight = minHeight + $('.pop_hdr', this).outerHeight();
            }
            if($('.pop_options', this).length){
                minHeight = minHeight + $('.pop_options', this).outerHeight();
            }
            if($('.pop_ftr', this).length){
                minHeight = minHeight + $('.pop_ftr', this).outerHeight();
            }
            
            newHeight = newHeight-minHeight-5;

            $('.pop_content').css('max-height', $('body').height()-minHeight-3);
        });
    }
}


// change status of plusklusitem button click
$('body').on('click', '.options .statuses button', function(e){
    e.preventDefault();
    
    var thisEl 		= $(this);
    var href 		= thisEl.attr('href');
    //var callback	= thisEl.attr('data-callback');
    var itemId 		= thisEl.attr('data-item-id');
    var statusId 	= thisEl.attr('data-status-id');
    var color 		= thisEl.attr('style').split(":")[1].replace(";", "");
    
    const data = {
        params: {
            itemid: itemId,
            newstate: statusId,
        }
    };
    
    axios.get(href, data)
        .then(function (respons) {
            // if success, update the status & color of the current html element
            if(thisEl.hasClass('faqStaBtn')){
                // faq
                var titleEl = thisEl.parents('.item_hld').find('.currStatus');
                
                // update color
                titleEl.css('background', color);
                
                // update / extend title
                titleEl.find('.stateInfo').remove();
                if(statusId == 2){
                    titleEl.append('<span class="stateInfo">(In afwachting)</span>');
                }else if(statusId == 3){
                    titleEl.append('<span class="stateInfo">(Afgekeurd)</span>');
                }
            }else{
                // plus klus lijst
                var title = "(" + thisEl.html() + ")";
                thisEl.parents('.item_hld').find('.title').css('color', color);
                thisEl.parents('.item_hld').find('.currStatus').html(title);
                
                $("#content").html(respons.data);
                //window.location.reload();
            }
        })
        .catch(function (error) {
            //cusAlert('Error', 'Could not get the add page. Are you logged in?');
        });
});


function updLocStaPlusklus(thisEl, color){
    // plus klus lijst
    var title = "(" + thisEl.html() + ")";
    thisEl.parents('.item_hld').find('.currStatus').css('color', color).html(title);
}


// show / hide reactions list
$('body').on('click', '.reaction_toggle_btn a', function(e){
    e.preventDefault();
    $(this).parents('.reaction_hld').find('.reaction_list_hld').toggle();
});

// submit add reaction form
$('body').on('submit', '.createEditReactionForm', function(e){
    e.preventDefault();
    var thisEl = $(this);
    var href = thisEl.attr('action');

    if(href){
        // get all form field values
        var formdata = new FormData(thisEl[0]);
        
        // post formdata to server
        axios.post(href, formdata)
            .then(function (response) {
                var retHtml = '<div class="reaction_item_hld"><h5 class="reaction_by">' + response.data.username + '</h5>' + response.data.text + '<button class="red delReactionBtn" href="' + response.data.delurl + '">Verwijder</button></div>';
                $('.reaction_list_hld[data-item-id='+ response.data.id +']').prepend(retHtml);
                
                // counter element					
                var ctrEl = $('.reaction_list_hld[data-item-id=' + response.data.id + ']').parents('.reaction_hld').find('.reaction_ctr');
                var currCtrVal = parseInt(ctrEl.html());
                
                // update counter value
                ctrEl.html(currCtrVal+1);
                
                // remove popup
                $('.bgPopup').remove();
            })
            .catch(function (error) {
                handleFieldErrors(error, thisEl);
            });
    }
});

// on delete this item button click
$('body').on('mouseenter', '.delReactionBtn', function(e){
    $(this).parent().css("border", "1px solid red");
});

// on delete this item button click
$('body').on('mouseleave', '.delReactionBtn', function(e){
    $(this).parent().css("border", "1px solid rgba(0,0,0,.125)");
});

// on delete this item button click
$('body').on('click', '.delReactionBtn', function(e){
    e.preventDefault();
    
    var thisEl 	= $(this);
    var href 	= thisEl.attr('href');
    var title 	= thisEl.attr('title');
    
    var delModal = new cusDialog("Delete", "Weet u zeker dat u deze reactie permanent wilt verwijderen?", function(){

        var formdata = new FormData();
        formdata.append('_method', 'DELETE');
        
        axios.post(href, formdata)
            .then(function (response) {
                // counter element
                var ctrEl = thisEl.parents('.reaction_hld').find('.reaction_ctr');
                var currCtrVal = parseInt(ctrEl.html());
                
                // remove reaction
                thisEl.parent().remove();
                
                // update counter value
                if(currCtrVal > 0){
                    ctrEl.html(currCtrVal-1);
                }
                
                // remove popup
                $('.bgPopup').remove();
            })
            .catch(function (error) {
                cusAlert('Error', 'Verwijderen mislukt, probeer het later nog eens. Als dit probleem zich blijft voordoen neem dan contact op met de beheerder.');
            });
    });
});


// category toggle button | open / close
$('body').on('click', '.toggleCatBtn', function(e){
    e.preventDefault();
    $(this).parents('.catToggleHld').find('.catToggleList').fadeToggle();
});


// category toggle button | open / close
$('body').on('click', '#mobMenu', function(e){
    e.preventDefault();
    $("#mainNavHld").toggle();
});





/**
control panel related function & actions
*/
$('body').on('click', '.actSeen', function(e){
    e.preventDefault();
    
    var thisEl 	= $(this);
    var href 	= thisEl.attr('href');

    axios.get(href)
        .then(function (respons) {
            thisEl.remove();
        })
        .catch(function (error) {
            cusAlert('Error', 'Kon deze activiteit niet als gelezen markeren.');
        });
});


// on add a new item (app, device, project) button click
$('body').on('click', '.addBtn', function(e){
    e.preventDefault();
    
    var href = $(this).attr('href');
    var title = $(this).attr('title');
    var addModal;

    axios.get(href)
        .then(function (respons) {
            addModal = new openPopup(title, respons.data);
            ckEditBox();
            //picUplBoxReplace();
        })
        .catch(function (error) {
            cusAlert('Error', 'Could not get the add page. Are you logged in?');
        });
});

// on edit this item button click
$('body').on('click', '.editBtn', function(e){
    e.preventDefault();
    
    var href = $(this).attr('href');
    var title = $(this).attr('title');
    var returnUrl = $(this).attr('data-return');
    var editModal;

    axios.get(href)
        .then(function (respons) {
            var rethtml = respons.data;
            if(returnUrl){
                rethtml = $(respons.data).attr('data-return', returnUrl).wrap('<p>').parent().html();
            }
            editModal = new openPopup(title, rethtml);
            ckEditBox();
            //picUplBoxReplace();
        })
        .catch(function (error) {
            //// console.log(error);
            cusAlert('Error', 'Could not get the edit page. Are you logged in?');
        });
        
    return false;
});

// on delete this item button click
$('body').on('click', '.delBtn', function(e){
    e.preventDefault();
    
    var href = $(this).attr('href');
    var title = $(this).attr('title');
    var returnUrl = $(this).attr('data-return');
    var itemId = $(this).attr('data-item-id');
    
    var delModal = new cusDialog("Delete", "Weet u zeker dat u dit permanent wilt verwijderen?", function(){

        var formdata = new FormData();
        formdata.append('_method', 'DELETE');
        
        axios.post(href, formdata)
            .then(function (response) {
                if(returnUrl){
                    window.location.href = returnUrl;
                }else{
                    // remove deleted item
                    $('.item_hld[data-item-id='+ itemId +']').remove();
                    
                    // remove popup
                    $('.bgPopup').remove();
                }
            })
            .catch(function (error) {
                cusAlert('Error', ',Verwijderen mislukt, probeer het later nog eens. Als dit probleem zich blijft voordoen neem dan contact op met de beheerder.');
            });
    });
});

// on add a new select item 
$('body').on('change', '.selAddNew', function(e){
    e.preventDefault();
    var newModal;
    
    if($(this).val() == 'N'){
        var href = $(this).attr('data-new-href');
        var title = $(this).attr('data-new-title');
        var name = $(this).attr('name');
        
        
        axios.get(href)
            .then(function (respons) {
                var rethtml = $(respons.data).attr('data-ret-select', name).wrap('<p>').parent().html();
                newModal = new openPopup(title, rethtml);
                ckEditBox();

            })
            .catch(function (error) {
                cusAlert('Error', 'Could not get the add page. Are you logged in?');
            });
    }
});

$('body').on('submit', '.createEditForm', function(e){
    e.preventDefault();
    var thisEl = $(this);
    var href = thisEl.attr('action');
    var selAddNew = thisEl.attr('data-ret-select');
    var returnUrl = thisEl.attr('data-return');

    
    
    if(href){
        // get all form field values
        var formdata = new FormData(thisEl[0]);
        
        // if image(file) is selected add it to the formdate object
        if($(this).find('image').length > 0){
            var file = thisEl.find('image')[0];
            formdata.set("image", file);
        }
        
        // post formdata to server
        axios.post(href, formdata)
            .then(function (response) {
                if(selAddNew){
                    
                    $("[name^='" + selAddNew + "']").empty().append('<option value="'+ response.data.id +'">'+ response.data.title +'</option>');
                    thisEl.parents('.bgPopup:first').remove();
                }else if(returnUrl){
                    window.location.href = returnUrl;
                }else if(response.data.url){
                    window.location.href = response.data.url;
                }
            })
            .catch(function (error) {
                handleFieldErrors(error, thisEl);
            });
    }
});



function handleFieldErrors(error, thisEl){
    var fieldErrors = Object.entries(error.response.data.errors)
    
    // remove previous errors
    $('.error').removeClass('error');
    $('.errorMessage').remove();
    
    // if specific fields failed highlight them and show error.
    // else show general error popup
    if(fieldErrors.length){
        // add errors to failed fields
        for(i=0; i < fieldErrors.length; i++){
            var thisEl = $("[name^='" + fieldErrors[i][0] + "']");
            
            if(thisEl.parents('.textarea').length){
                thisEl.parents('.textarea').addClass('error');
                thisEl.parents('.textarea').after('<small class="errorMessage">'+ fieldErrors[i][1][0] +'</small>');
            }else{
                thisEl.addClass('error');
                thisEl.after('<small class="errorMessage">'+ fieldErrors[i][1][0] +'</small>');
            }
            
        };
    }else{
        cusAlert('Error', 'Could not save this data: '+ error.response.data.message);
    }
}
    
    
    
    
    
    
    

/**
control panel page specific related function & actions
*/

/**
 * on .addFromListBtn click
 * used in de cp projects page
 * adds device to the opend project 
*/ 
$('body').on('click', '.addFromListBtn', function(e){
    e.preventDefault();
    
    var href = $(this).attr('href');
    var title = $(this).attr('title');
    var retItem = $(this).attr('data-org-field');
    var retList = $(this).attr('data-org-list');
    var addModal;
    
    const data = {
        params: {
            selected: $("[name^='" + retItem + "']").val(),
        }
    };

    axios.get(href, data)
        .then(function (respons) {
            
            addModal = new openPopup(title, respons.data);
            
            $('.popupCnt').on('click', '.item_list_hld .pch_item', function(e){
                var thisItem = $(this);
                var id = thisItem.attr('data-id');
                
                if(thisItem.hasClass('used')){
                    
                    //var project = '<a href="' + thisItem.attr('data-used-url') + '" target="_blank">' + thisItem.attr('data-used-title') + '</a>';
                    var project = thisItem.attr('data-used-title');
                    
                    
                    cusDialog("Already used", 'This device is already used in an other project called "'+ project +'"</br>If you continue it will be removed from the other project. Continue?', function(thisPopup){
                        // yes function
                        
                        if(retItem == "device_id"){
                            devToProj(retList, thisItem, retItem, id);
                        }else{
                            appToProj(retList, thisItem, retItem, id);
                        }
                        
                        // close popup
                        thisPopup.closePopup();
                        addModal.closePopup();

                        
                    }, function(thisPopup){
                        // close popup
                        thisPopup.closePopup();
                    });
                }else{
                
                    if(retItem == "device_id"){
                        devToProj(retList, thisItem, retItem, id);
                    }else{
                        appToProj(retList, thisItem, retItem, id);
                    }
                    
                    
                    // close popup
                    addModal.closePopup();
                    
                }
            });
        })
        .catch(function (error) {
            cusAlert('Error', 'Could not get the add page. Are you logged in?');
        });
});



function fb_search(searchfor){
if(searchfor != ""){
    $(".popupCnt .pch_item").each(function(){
        var found = false;
        
        if($('.pch_item_title', this).text().indexOf(searchfor) > -1){
            found = true;
        }else if($('.pch_item_title', this).text().toUpperCase().indexOf(searchfor) > -1){
            found = true;
        }else if($('.pch_item_title', this).text().toLowerCase().indexOf(searchfor) > -1){
            found = true;
        }
        
        if(found){
            $(this).fadeIn().addClass('result');
        }else{
            $(this).fadeOut().removeClass('result');
        }
    });
}else{
    $(".popupCnt .pch_item").fadeIn().removeClass('result');
}
}

function minMaxAttr(selector, attr) {
var min=null, max=null;
$(selector).each(function() {
var val = parseInt($(this).attr(attr));
if ((min===null) || (val < min)) { min = val; }
if ((max===null) || (val > max)) { max = val; }
});
return {min:min, max:max};
}

























function pchItemTemp(hldHtml = "", hldClass = ""){
    var retHtml = '';
    
    retHtml += '<div class="pch_item">';
    retHtml += '	<div class="pch_item_hld '+ hldClass +'">';
    retHtml += 			hldHtml;
    retHtml += '	</div>';
    retHtml += '</div>';
    
    return retHtml;
}

function pchItemInfo(hldHtml = "", hldClass = "", title = "", detail = "", desc = ""){
    var retHtml = '';
    
    retHtml += '<div class="pch_item_info '+ hldClass +'">';
    retHtml += '	<div class="pch_item_title">'+ title +'</div>';
    retHtml += '	<div class="pch_item_detail">'+ detail +'</div>';
    retHtml += '	<div class="pch_item_desc">'+ desc +'</div>';
    retHtml += 		hldHtml;
    retHtml += '</div>';
    
    return retHtml;
}


function picUplBoxReplace(org = '.picUplBox_RP'){
    Dropzone.autoDiscover = false;
    var nameEl;
    var picDropSelHtml = '<div class="pub_add"><div class="drop"><span>Drop image</span></div><div class="or">OR</div><div class="click frBtn"><span>Click here</span></div><input class="fileRemove" type="file" name="files"></div><input type="hidden" class="nval" name="{nameEl}" value="">';

    var picPrevHtml = '<div><div class="pch_item_pic"><img src="/img/noimg_th.png" data-dz-thumbnail></div><div class="pch_item_info dz-details"><div class="pch_item_title dz-filename"></div><div class="pch_item_detail dz-size"></div><div class="pch_item_desc"><div class="pub_ldr_progress dz-progress"><div class="bar"></div></div></div></div><div class="options"><a href="#" target="_parent" class="pub_viewBtn"><img src="/img/icons/clr/16/view.png"/></a><a href="#" target="_parent" class="pub_delBtn"><img src="/img/icons/clr/16/delete.png"/></a></div></div>';
    
    
    
    
    // loop all elements and replace them with 'fancy' picture upload box
    $(org).each(function(){
        nameEl = $(this).attr("name");
        var dirEl = $(this).attr("data-dir");
        var valEl = $(this).attr("data-val");
        var delPic = $(this).attr("data-delpic");
        
        //// console.log(dirEl);
        //// console.log(valEl);
        
        picDropSelHtml = picDropSelHtml.replace(/{nameEl}/g,nameEl);
        picDropSelHtml = pchItemTemp(picDropSelHtml, 'picUplBox box_'+ nameEl +' dropzone-previews');
        
        
        $(this).replaceWith(picDropSelHtml);
        
        if(valEl != ""){					
            $('.box_'+nameEl).append(picPrevHtml);
            
            
            $('.box_'+nameEl+' .pch_item_pic img').attr("src", dirEl+valEl);
            $('.box_'+nameEl+' .pch_item_title').html(imageShortTitle(valEl));
            $('.box_'+nameEl+' .pch_item_detail').html("Type: image/"+imageExt(valEl));
            $('.box_'+nameEl+' .pch_item_desc .pub_ldr_progress').hide();
            $('.box_'+nameEl+' .options .pub_delBtn').attr("data-delpic", delPic);
            $('.box_'+nameEl+' .options').show();
            $('.box_'+nameEl+' .options .pub_viewBtn').attr('target', '_blank').attr('href', (dirEl+valEl).replace('th','xl'));

            
            $('.box_'+nameEl+' .pub_add').hide();
            $('.box_'+nameEl+' .pch_item_pic').show();
            $('.box_'+nameEl+' .pch_item_info').show();
        }
        
        // setup the dropzone.js library for this element
        $(".picUplBox").dropzone({
            url: "/upload", 
            params: { _token: $('meta[name="csrf-token"]').attr('content') },
            
            maxFiles: 1,
            acceptedFiles: "image/*",
            
            thumbnailWidth: 78,
            thumbnailHeight: 50,
            
            resizeWidth: 1920,
            resizeQuality: 1,
            previewsContainer: '.picUplBox',
            previewTemplate: picPrevHtml,
            init: function() {
                var tdz = this;
                tdz.on("addedfile", function(file) {
                    $('.box_'+nameEl+' .pub_add').hide();
                    $('.box_'+nameEl+' .pch_item_pic').show();
                    $('.box_'+nameEl+' .pch_item_info').show();
                }),
                tdz.on("uploadprogress", function(file, progress, bytesSent) {
                    /* Maybe display some more file information on your page */
                    $('.box_'+nameEl+' .pub_loader .bar').width(progress + "%");
                }),
                tdz.on("success", function(file, response) {
                    $('.box_'+nameEl+' .nval').val(response.files[0].name);
                    $('.box_'+nameEl+' .pub_ldr_progress ').hide();
                    $('.box_'+nameEl+' .options').show();
                }),
                tdz.on("complete", function(file) {
                    my.removeAllFiles(file);
                });
                
                $('.box_'+nameEl).on('click','.click',function(e){
                    $(".picUplBox").get(0).dropzone.hiddenFileInput.click();
                });
                $('.box_'+nameEl).on('click','.pub_delBtn',function(e){
                    e.preventDefault();
                    var thisError = false;
                    var delhref = $(this).attr("data-delpic");
                    
                    if(delhref){
                        axios.get(delhref)
                            .catch(function (error) {
                                thisError = true;
                                cusAlert('Error', 'Could not delete this image.');
                            });
                    }
                    
                    if(!thisError){
                        tdz.emit("resetFiles");
                        tdz.removeAllFiles();
                        
                        $('.box_'+nameEl+' .pch_item_pic').remove();
                        $('.box_'+nameEl+' .pch_item_info').remove();
                        $('.box_'+nameEl+' .options').hide();

                        
                        //$(this).parents('.pub_loader').remove();
                        $('.box_'+nameEl+' .nval').val("");
                        
                        $('.box_'+nameEl+' .pub_loader .pub_ldr_pic img').attr("src", "/cp/img/noimg_th.png");
                        $('.box_'+nameEl+' .pub_loader .pub_ldr_progress').show();
                        $('.box_'+nameEl+' .pub_loader .options').hide();
                        $('.box_'+nameEl+' .pub_add').show();
                    }
                });
            }
        });
    });
    
    

}


function imageShortTitle(title, max = 16){
    var retString = title;
    if(title.length > max){
        var parts = title.split(".");
        retString = parts[0].substring(0, max)+"..."+parts[1];
    }
    return retString;
}

function imageExt(title){
    var parts = title.split(".");

    return parts[1];
}

function twoDigit(value) {
    return (value < 10) ? '0' + value : '' + value;
}
function reload_page(){
    window.location.reload(true);
}



$(document).ready(function(){
    var curropen = false;
    $( "#flt_dev,#flt_app,#flt_proj" ).change(function() {
        $("form[name='logfilter']").submit();
        return false;
    });
    $( ".log_field_choice_btn a" ).click(function() {
        if($(".log_field_choices").is(":visible")){
            $( ".log_field_choices" ).slideUp( "slow");
        }else{
            $( ".log_field_choices" ).slideDown( "slow");
        }
        return false;
    });
    $( ".log_field_choice_cancel" ).click(function() {
        $( ".log_field_choices" ).slideUp( "slow");
        return false;
    });
});
